import script from "./d3d-model.vue?vue&type=script&lang=ts&setup=true"
export * from "./d3d-model.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__